/**
 * 誌面印刷 ページ一覧リクエスト用VO
 *
 * @export PageDataModel
 * @class PageDataModel
 */
export class PageDataModel {
  /**
   * 受注コード
   */
  public orderCode = String('');

  /**
   * 媒体区分
   */
  public mediumType = String('');

  /**
   * 会員生協コードコード
   */
  public coopCodeList: Array<any> = null;
}
